<template>
  <app-layout class="">
    <div class="info-passengers" :class="routeLogin ? 'class-login' : ''">
      <transition name="slide-fade" appear mode="out-in">
        <router-view></router-view>
        <!-- <input-code-component v-if="!validCode" key="input"></input-code-component>
        <passengers-component v-else key="passengers"></passengers-component> -->
      </transition>
    </div>
    <snackbar-component></snackbar-component>
  </app-layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { NIGHTS_FETCH_AND_SET_EXTRAS } from "../../store/nights/action-types";
import { SET_RESERVATION_CODE_ACTION } from "../../store/reserve-area/action-types";
import {
  GET_RESERVATION,
  GET_RESERVATION_CODE,
  GET_VALID_CODE,
} from "../../store/reserve-area/getter-types";
export default {
  data: () => {
    return {
      routesAndStates: {
        created: "reserve-area-portal",
        paid: 'reserve-area-portal',
        confirmed: "reserve-area-form",
        "second-notice": "reserve-area-form",
        "data-sent": "reserve-area-summary",
        "boarding-passes": "reserve-area-summary",
        "cancelled" : "reserve-area-portal",
        "reimbursed" : "reserve-area-portal",
        "completed" : "reserve-area-portal",
        "payment-declined" : "reserve-area-portal"
      },
      unsubscribe: null,
    };
  },
  computed: {
    ...mapGetters({
      validCode: GET_VALID_CODE,
      reservationCode: GET_RESERVATION_CODE,
      reservation: GET_RESERVATION,
    }),
  },
  methods: {
    ...mapActions({
      setReservationCode: SET_RESERVATION_CODE_ACTION,
    }),
    handleWhereToRedirect(code, status) {
      this.$router.push({
        name: this.routesAndStates[status],
        params: { code: code },
      });
    },
  },
  watch: {
    validCode(validCode) {
      validCode &&
        this.$route.name == "reserve-area-portal" &&
        this.$router.push({
          name: this.routesAndStates[this.reservation.status],
          params: { code: this.reservationCode },
        });
    },
  },
  computed: {
    routeLogin() {
      if (this.$route.path.includes("portal")) {
        return true;
      }
      return false;
    },
  },
  created() {
    this.setReservationCode("");
    this.unsubscribe = store.subscribe((mutation, state) => {
      if (
        mutation.type === "SET_VALID_CODE_TO_TRUE" ||
        mutation.type === "SET_RESERVATION_STATUS"
      ) {
        const routeToRedirect =
          this.routesAndStates[state.reservationReserve.status];

        const noRedirectableRoutes = [routeToRedirect, 'reserve-area-comfirm', 'reserve-area-extras']

        if (noRedirectableRoutes.includes(this.$route.name)) return;

        this.$router.push({
          name: this.routesAndStates[state.reservationReserve.status],
          params: { code: state.reservationReserve.code },
        });
      }
    });

    const code = this.$route.params.code || null;
    if (code === null) return;
    this.setReservationCode(code);
  },
  beforeDestroy() {
    this.unsubscribe();
  },
};
</script>

<style lang="scss">
@import "../../../sass/variables";
hr {
  border-color: #9b9b9b;
}

.info-passengers {
  background-color: $paleGrey;
  display: flex;
  flex-direction: column;
  // align-items: center;
  /*   justify-content: center; */
  min-height: 80vh;
  width: 100%;
  padding: 1rem 1rem 3rem;
  margin: auto;

  @media (min-width: 1024px) {
    padding-bottom: 5rem;
  }

  .input-group {
    width: 100%;
  }
}
.class-login {
  justify-content: center;
  background-color: transparent;
  background-image: url("/img/area-reserva-img.webp");
  @media (max-width: 600px) {
    background-image: url("/img/area-reserva-img-mobile.webp");
  }
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(200px);
  opacity: 0;
}
</style>
